<template>
  <div class="outerBlock">
    <div class="basicInfo">
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :value="basicInfo.blNo" disabled label="BLNo"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :value="basicInfo.containerCount" disabled label="SEA-FCL"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :value="basicInfo.eta" disabled label="ETA"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :value="basicInfo.freightConfirmDate" disabled label="フレイト計算日"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout :key="key" row v-for="(branch,key) in basicInfo.branches" wrap>
        <v-flex md12 sm6 xs12>
          枝番{{branch.branchCode}}
          <Br/>
          {{branch.confirmDate}}DO確定
          <Br/>
          纳入予定日{{branch.forecastDeliveryDate}}
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :value="basicInfo.lastAgreeDate" disabled label="諸掛承認日"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout :key="key" row v-for="(freight,key) in basicInfo.freights" wrap>
        <v-flex md12 sm6 xs12>海上運賃{{freight.currencyCode}} {{freight.price}}</v-flex>
      </v-layout>
      <v-layout
        :key="key"
        row
        v-for="(drake,key) in basicInfo.drakes"
        wrap
      >ドレージ{{drake.currencyCode}}{{drake.price}}(台)*{{drake.count}}</v-layout>
    </div>
    <div class="timelineA">
      <v-layout>
        <v-flex :key="key" md3 sm6 v-for="(result,key) in basicInfo.yearMonths" xs12>
          <time-line :result="result"></time-line>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import TimeLine from '@/components/TimeLine'
export default {
  components: { TimeLine },
  mounted() {
    this.$http.get('/arap/finance/19S0001336/bl-information').then(res => {
      this.basicInfo = res.data
    })
  },
  data() {
    return {
      basicInfo: {}
      // basicInfo: {
      //   mbl: 'MBL001',
      //   hbl: 'HBL001',
      //   transportMode: 'SEA',
      //   stackType: 'FCL',
      //   eta: '2019/6/29',
      //   freightCalDay: '2019/7/02',
      //   doNo: 'DO001',
      //   domesticConfirmDate: '2019/09/04',
      //   usd: 'USD1000',
      //   comfirmDate: '2019/09/10',
      //   jpy: 'JPY20000',
      //   branches: [
      //     { branchCode: '001', id: '1' },
      //     { branchCode: '002', id: '2' },
      //     { branchCode: '003', id: '3' },
      //     { branchCode: '004', id: '4' }
      //   ]
      // },
      // results: [
      //   {
      //     events: [
      //       { description: '第一个月' },
      //       { description: '第二个月' },
      //       { description: '第三个月' },
      //       { description: '第四个月' },
      //       { description: '第五个月' },
      //       { description: '第六个月' },
      //       { description: '第七个月' },
      //       { description: '第八个月' },
      //       { description: '第九个月' },
      //       { description: '第十个月' }
      //     ],
      //     yearMonth: '2019/10',
      //     month: 9
      //   },
      //   {
      //     events: [
      //       { description: '第一个月' },
      //       { description: '第二个月' },
      //       { description: '第三个月' }
      //     ],
      //     yearMonth: '2019/11',
      //     month: 10
      //   },
      //   {
      //     events: [
      //       { description: '第一个月' },
      //       { description: '第二个月' },
      //       { description: '第三个月' }
      //     ],
      //     yearMonth: '2019/12',
      //     month: 11
      //   },
      //   {
      //     events: [
      //       { description: '第一个月' },
      //       { description: '第二个月' },
      //       { description: '第三个月' }
      //     ],
      //     yearMonth: '2019/12',
      //     month: 11
      //   },
      //   {
      //     events: [
      //       { description: '第一个月' },
      //       { description: '第二个月' },
      //       { description: '第三个月' }
      //     ],
      //     yearMonth: '2019/12',
      //     month: 11
      //   },
      //   {
      //     events: [
      //       { description: '第一个月' },
      //       { description: '第二个月' },
      //       { description: '第三个月' }
      //     ],
      //     yearMonth: '2019/12',
      //     month: 11
      //   },
      //   {
      //     events: [
      //       { description: '第一个月' },
      //       { description: '第二个月' },
      //       { description: '第三个月' }
      //     ],
      //     yearMonth: '2019/12',
      //     month: 11
      //   },
      //   {
      //     events: [
      //       { description: '第一个月' },
      //       { description: '第二个月' },
      //       { description: '第三个月' }
      //     ],
      //     yearMonth: '2019/12',
      //     month: 11
      //   }
      // ]
    }
  }
}
</script>
<style scoped>
.basicInfo {
  width: 20%;
  overflow: auto;
  display: inline-block;
  flex-direction: column;
  /* border: 1px red solid; */
}

.timelineA {
  width: 80%;
  overflow: auto;
  display: inline-block;
  flex-direction: row;
  margin-top: 30px;
  margin-left: 30px;
  height: auto;
  /* border: 1px red solid; */
}

.outerBlock {
  /* border: 1px solid red; */
  display: flex;
  height: 100%;
}
</style>